import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { initializeFirestoreData } from '@/services/database/initialization';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const initializeFirestore = async () => {
  try {
    await enableIndexedDbPersistence(db, {
      cacheSizeBytes: CACHE_SIZE_UNLIMITED
    });

    await initializeFirestoreData();
  } catch (err: any) {
    if (err.code === 'failed-precondition') {
      console.info('Firebase persistence is only enabled in one tab at a time');
    } else if (err.code === 'unimplemented') {
      console.info('This browser does not support offline persistence');
    }
  }
};

initializeFirestore().catch(console.error);

export const collections = {
  users: 'users',
  assessments: 'assessments',
  evaluators: 'evaluators',
  feedback: 'feedback',
  objectives: 'objectives',
  plans: 'plans',
  objectiveSelections: 'objectiveSelections',
  automations: 'automations',
  reports: 'reports' // Add reports collection
};

export { app, auth, db };